/*
  tis-page-colour-lock.js  2026-08-25

  Problem
  -------
  Each colourway is its own product carrying custom.colour_name, but the product page
  exposes only a SIZE selector. The colour therefore comes from whichever variant sits
  first in variant order. On 59 products that is a different colour from the one the page
  advertises, so the cart receives a colour the customer never chose.

  snippets/tis-page-variant-id.liquid corrects the SERVER rendered value. This file stops
  the theme's variant picker from overwriting it again. Both halves are required.

  Note on structure: every lookup happens inside run(), never at parse time. This script
  is injected before the markup it operates on, so anything resolved at parse time is
  null and the whole guard silently does nothing.

  Rules
  -----
  - Size is never changed, only colour is corrected.
  - If the current size does not exist in the page colour, nothing is touched.
  - An explicit ?variant= in the URL always wins and disables the guard.
*/
(function () {
  if (window.__tisPageColourLock) return;
  window.__tisPageColourLock = true;

  var SIZE_RE = /^(xs|s|m|l|xl|2xl|3xl|4xl|small|medium|large|one size)$/;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().trim()
      .replace(/[&\/]/g, ' ')
      .replace(/\b(with|trim|trims|cuff|cuffs)\b/g, ' ')
      .replace(/navy blue/g, 'navy')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function variantColour(v) {
    if (!v || !v.options) return '';
    for (var i = 0; i < v.options.length; i++) {
      var o = norm(v.options[i]);
      if (o && !SIZE_RE.test(o)) return o;
    }
    return norm(v.options[0]);
  }

  function variantSize(v) {
    if (!v || !v.options) return '';
    for (var i = 0; i < v.options.length; i++) {
      var o = norm(v.options[i]);
      if (SIZE_RE.test(o)) return o;
    }
    return norm(v.options[v.options.length - 1]);
  }

  function readVariants() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        if (Array.isArray(d) && d.length && d[0] && d[0].id && d[0].options) return d;
      } catch (e) { /* not this one */ }
    }
    return null;
  }

  // Captured ONCE, at parse time, before the theme's own picker can touch the URL.
  // The picker calls history.replaceState with its own variant shortly after load, so
  // reading location.search inside run() made this guard disable itself a moment later.
  var HAD_EXPLICIT_VARIANT = /[?&]variant=/.test(window.location.search);

  function run() {
    if (HAD_EXPLICIT_VARIANT) return;

    var anchor = document.querySelector('[data-tis-page-colour]');
    if (!anchor) return;
    var pageColour = norm(anchor.getAttribute('data-tis-page-colour'));
    if (!pageColour) return;

    var variants = readVariants();
    if (!variants) return;

    var inColour = [];
    for (var i = 0; i < variants.length; i++) {
      if (variantColour(variants[i]) === pageColour) inColour.push(variants[i]);
    }
    if (!inColour.length) return;   // colour genuinely not sold on this product

    var inputs = document.querySelectorAll('input[name="id"], select[name="id"]');
    for (var k = 0; k < inputs.length; k++) {
      var el = inputs[k];
      var current = null;
      for (var m = 0; m < variants.length; m++) {
        if (String(variants[m].id) === String(el.value)) { current = variants[m]; break; }
      }
      if (!current || variantColour(current) === pageColour) continue;

      var wantSize = variantSize(current);
      var replacement = null;
      for (var n = 0; n < inColour.length; n++) {
        if (variantSize(inColour[n]) === wantSize) { replacement = inColour[n]; break; }
      }
      if (!replacement) continue;   // size not available in this colour, do not guess
      el.value = String(replacement.id);
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
  }

  function safeRun() { try { run(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeRun);
  }
  safeRun();

  // The picker is a custom element and rewrites the input at an unpredictable moment,
  // so re-assert over a short window rather than betting on one delay.
  var ticks = 0;
  var poll = setInterval(function () { safeRun(); if (++ticks > 40) clearInterval(poll); }, 250);

  document.addEventListener('change', function (e) {
    if (e && e.target && e.target.name === 'id') return;
    setTimeout(safeRun, 60);
  }, true);

  // Last line of defence, so whatever else happened the submitted value is correct.
  document.addEventListener('submit', function (e) {
    var f = e && e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) safeRun();
  }, true);
})();
